'use client'

import React, { useEffect, useState } from 'react'
import { Box } from '@mantine/core'
import TestimonialCarousel from '@/components/TestimonialCarousel'
import { useIsMobile } from '@/lib/mobileDetector'

export interface Testimonial {
    id: string
    customerName: string
    location: string
    quote: string
    description: string
    desktopImageUrl: string
    mobileImageUrl: string
}

const testimonials: Testimonial[] = [
    {
        id: '1',
        customerName: 'Damon',
        location: 'Texas',
        quote: 'They took me seriously. I got an appointment the same day. They saved my show.',
        description:
            'Damon needed his voice fixed fast—waiting weeks for a doctor wasn’t an option. With General Medicine, he got specialist care and treatment in days.',
        desktopImageUrl: 'testimonials/store-customer-damon-desktop.jpg',
        mobileImageUrl: 'testimonials/store-customer-damon-mobile.jpg',
    },
    {
        id: '2',
        customerName: 'Ashley',
        location: 'Colorado',
        quote: 'General Medicine made the process super easy. It eliminated so much stress.',
        description:
            'After 15+ years of runaround, Ashley got the dermatology care she needed in just six weeks. We handled the referrals, surgery scheduling, and care from start to finish so she could finally focus on getting better.',
        desktopImageUrl: 'testimonials/store-customer-ashley-desktop.jpg',
        mobileImageUrl: 'testimonials/store-customer-ashley-mobile.jpg',
    },
    {
        id: '3',
        customerName: 'Lori',
        location: 'Michigan',
        quote: 'The doctor was just as concerned with helping me feel better as he was with me being cured.',
        description:
            'When Lori needed UTI treatment over the holiday, we connected her to a doctor and filled her prescription within hours. No urgent care or waiting rooms, just fast relief.',
        desktopImageUrl: 'testimonials/store-customer-lori-desktop.jpg',
        mobileImageUrl: 'testimonials/store-customer-lori-mobile.jpg',
    },
    {
        id: '4',
        customerName: 'Scott',
        location: 'Colorado',
        quote: 'It was just really different than a normal visit to a doctor.',
        description:
            'Getting healthcare was stressful without insurance—until Scott found us. With transparent pricing and hassle-free care, he could finally manage his blood pressure without any insurance headaches.',
        desktopImageUrl: 'testimonials/store-customer-scott-desktop.jpg',
        mobileImageUrl: 'testimonials/store-customer-scott-mobile.jpg',
    },
]

const TestimonialsSection: React.FC = () => {
    const isMobile = useIsMobile(1280)
    const [randomizedTestimonials, setRandomizedTestimonials] = useState<Testimonial[]>([])

    useEffect(() => {
        // Function to randomize the starting testimonial
        const randomizeStartingTestimonial = () => {
            const randomIndex = Math.floor(Math.random() * testimonials.length)

            const reordered = [...testimonials.slice(randomIndex), ...testimonials.slice(0, randomIndex)]

            setRandomizedTestimonials(reordered)
        }

        randomizeStartingTestimonial()
    }, [])

    if (randomizedTestimonials.length === 0) {
        return null
    }

    return (
        <Box style={{ background: 'var(--gm-background-bg-primary)' }}>
            <TestimonialCarousel
                testimonials={randomizedTestimonials}
                title="Real people, real results"
                subtitle="Join the tens of thousands getting healthcare the easier way"
            />
        </Box>
    )
}

export default TestimonialsSection
